import React from 'react';
import {
  PageTitle,
  Container,
  Main,
  Sidebar,
  SidebarContent,
  SidebarImage,
} from './Content.style';
import Page from '../../components/Page/Page';
import Headline from '../../components/Headline/Headline';
import Text from '../../components/Text/Text';
import Image from '../../components/Image/Image';

// Icons
import iconBedienung from '../../assets/images/icons/icon-bedienung.svg';
import iconEssen from '../../assets/images/icons/icon-essen.svg';
import iconExtras from '../../assets/images/icons/icon-extras.svg';
import iconKontakt from '../../assets/images/icons/icon-kontakt.svg';
import iconPalme from '../../assets/images/icons/icon-palme.svg';
import iconRundgang from '../../assets/images/icons/icon-rundgang.svg';
import iconWerbefilm from '../../assets/images/icons/icon-werbefilm.svg';

const icons = {
  ausflugstipps: iconPalme,
  restauranttipps: iconEssen,
  'extras-und-verleih': iconExtras,
  'bedienung-und-anleitungen': iconBedienung,
  'rundgang-hausboote': iconRundgang,
  'werbefilm-hausboote': iconWerbefilm,
  'hilfe-und-kontakt': iconKontakt,
};

const ContentPage = ({ title, teaser, content, icon }) => {
  return (
    <Page background={false}>
      <PageTitle>{title}</PageTitle>

      <Container>
        {teaser && (
          <Sidebar>
            <SidebarContent dangerouslySetInnerHTML={{ __html: teaser }} />
            <SidebarImage src={icons[icon]} />
          </Sidebar>
        )}

        <Main>
          {content.map((element, index) => {
            switch (element.type) {
              case 'headline':
                return (
                  <Headline
                    key={index}
                    unit={element.headline.unit}
                    value={element.headline.value}
                  />
                );
              case 'text':
                return <Text key={index} content={element} />;
              case 'image':
                return <Image key={index} content={element} />;
              default:
                return null;
            }
          })}
        </Main>
      </Container>
    </Page>
  );
};

export default ContentPage;
